<template>
	<component :is="component" :data="data" v-if="component" />
</template>

<script>
export default {
	props: ['data', 'service', 'type'],
	data () {
		return {
			component: null
		};
	},
	computed: {
		loader () {
			if (!this.type) {
				return () => { return { then: () => {} }; };
			}
			return () => import(`@/views/${this.service}/tabs/${this.type}`);
		}
	},
	methods: {
		load () {
			this.loader()
				.then(() => {
					this.component = () => this.loader();
					this.$emit('loaded');
				});
		},
		unload () {
			this.component = null;
		}
	},
	watch: {
		type: {
			handler () {
				if (this.type === null) {
					return this.unload();
				}
				this.load();
			}
		}
	},
	mounted () {
		this.load();
	}
};
</script>
